import React, { memo, useCallback, useEffect, useState } from "react";
import styles from "./MostRecentOrderTab.module.scss";
import OrderDetailsSideDialog from "../../../components/OrderDetailsSideDialog/OrderDetailsSideDialog";
import CommonPagination from "../../../../../common/components/pagination/CommonPagination";
import { OrderStatus, OrderType, OrderWithReducedDetails } from "../../../../../model/orders/orders";
import solarProviderService from "../../../../../httpService/SolarProviderService";
import { toast } from "react-toastify";
import { formatDate } from "../../../../../utils";
import { ProviderCustomerOrder } from "../../../../../model/customer/customer";
type Props = {
	startDate: Date;
	endDate?: Date;
};

const MostRecentOrderTab = memo((props: Props) => {
	const { startDate, endDate } = props;

	const [viewDetails, setViewDetails] = useState(false);
	const [selectedOrder, setSelectedOrder] = useState<ProviderCustomerOrder | undefined>();

	const pageSize = 6;
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState<ProviderCustomerOrder[]>([]);

	const previewDetails = (order: any) => {
		setSelectedOrder(order);
		setViewDetails(true);
	}

	const fetchOrders = useCallback(async () => {
		try {
			setLoading(true);
			const response = await solarProviderService.getMostRecentOrders(currentPage, pageSize, startDate, endDate)
			setTotalPages(response.data.totalPages);
			setData(response.data.items);
		} catch (error : any) {
			toast.error(error.response.data.title || "Something went wrong. Please try again.");
		} 
		finally {
			setLoading(false);
		}
	}, [currentPage, startDate, endDate]);

	function onUpdatedOrderStatus(orderId: string, newStatus: OrderStatus) {
		const updatedOrders = data.map(order => {
			if (order.id === orderId) {
				return {
					...order,
					status: newStatus
				};
			}
			return order;
		});
		setData(updatedOrders);
		setSelectedOrder(undefined);
		setViewDetails(false);
	}

	useEffect(() => {
		fetchOrders();
	}, [fetchOrders]);

	return (
		<section>
			<div className={styles.tableContainer}>
				<table className="standardTable">
					<thead>
						<tr>
							<th>CUSTOMER NAME</th>
							<th>PRODUCT ORDERED</th>
							<th>PAYMENT DATE</th>
							<th>ORDER STATUS</th>
							<th>DATE STATUS CHANGED</th>
							<th>VIEW DETAILS</th>
						</tr>
					</thead>
					<tbody>
						{data.map((order, index) => (
							<tr key={order.id}>
								<td>{order.customerName}</td>
								<td>{order.productName}</td>
								<td>{formatDate(order.paymentDate ?? "")} </td>
								<td>{order.status}</td>
								<td>{formatDate(order.statusChanged ?? "")}</td>
								<td>
									<button className={`actionButton`} onClick={() => previewDetails(order)}>
										VIEW DETAILS
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className={styles.paginationContainer}>
				<CommonPagination
					currentPage={currentPage}
					isLoading={loading}
					numberOfPages={totalPages}
					onPageChange={(page: number) => {
						setCurrentPage(page);
					}}
				/>
			</div>

			{viewDetails && <OrderDetailsSideDialog order={selectedOrder!} onCloseDialog={() => setViewDetails(false)} onUpdateOrderStatus={onUpdatedOrderStatus} />}
		</section>
	);
});

export default MostRecentOrderTab;
